import { render, staticRenderFns } from "./CultureDesignMaterialInboundInfo.vue?vue&type=template&id=5730bb69&scoped=true&"
import script from "./CultureDesignMaterialInboundInfo.vue?vue&type=script&lang=js&"
export * from "./CultureDesignMaterialInboundInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5730bb69",
  null
  
)

export default component.exports